<template>
  <el-dialog
    v-model="formVisible"
    title="查询表单配置"
    @close="close"
    width="45%"
    class="setUpDialog"
  >
    <h-table
      ref="tableRef"
      v-model:columns="columns"
      :params="tableParams"
      :method="configureList"
    >
      <template #display="{ row }">
        <el-switch
          :value="row.display"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="1"
          inactive-value="0"
          @change="changeStatus(row)"
        ></el-switch>
        <span style="margin-left: 15px">
          {{ row.display === "1" ? "展示" : "隐藏" }}</span
        >
      </template>
      <template #default="{ row }">
        <el-button size="small" type="primary" @click="editorClick(row)"
          >编辑</el-button
        >
        <el-button size="small" type="danger" @click="delClick(row)"
          >删除</el-button
        >
      </template>
    </h-table>
    <template #footer>
      <h-button type="primary" @click="addForm">添加</h-button>
    </template>
  </el-dialog>
  <el-dialog
    v-model="addVisible"
    title="添加"
    width="25%"
    @close="addClose(ruleFormRef)"
  >
    <el-form
      ref="ruleFormRef"
      :inline="false"
      :rules="rules"
      :model="addParams"
      class="addForm"
      label-width="120px"
    >
      <el-form-item
        v-if="lableDataDict"
        label="字段列表："
        prop=""
        width="70px"
      >
        <el-select v-model="labelList" placeholder="请选择" :clearable="true">
          <el-option
            v-for="item in lableDataDict"
            :key="item"
            @click="lableDataClick(item)"
            :label="item.label"
            :value="item.prop"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="字段名称：" prop="name">
        <el-input v-model="addParams.name" placeholder=""></el-input
      ></el-form-item>
      <el-form-item label="字段值：" prop="fields">
        <el-input v-model="addParams.fields" :disabled="true"></el-input
      ></el-form-item>
      <el-form-item label="字段类型：" prop="defaultConfiguration">
        <h-selectcode
          v-model:dictData="defaultConfigurationList"
          v-model="addParams.defaultConfiguration"
          placeholder=" "
          @change="changeDefaultConfiguration"
        ></h-selectcode>
      </el-form-item>
      <el-form-item label="字段排序：" prop="">
        <el-input v-model.number="addParams.seq"></el-input>
      </el-form-item>
      <el-form-item label="是否显示：" prop="">
        <el-switch
          v-model="addParams.display"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="1"
          inactive-value="0"
        ></el-switch
      ></el-form-item>
      <el-form-item label="筛选类型：" prop="operators">
        <h-selectcode
          v-if="operatorsList"
          v-model:dictData="operatorsList"
          v-model="addParams.operators"
          :multiple="true"
          placeholder=" "
        ></h-selectcode
      ></el-form-item>
      <el-form-item
        v-show="addParams.operators.includes('10')"
        label="数据字典："
        prop=""
      >
        <el-select
          v-model="addParams.dictConversion"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="it in dictList"
            :key="it.type"
            :label="it.name + '——' + it.type"
            :value="it.type"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template #footer>
      <h-button type="primary" @click="submit(ruleFormRef)">保存</h-button>
      <h-button @click="addClose">关闭</h-button>
    </template>
  </el-dialog>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
  nextTick,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import _ from "lodash";

import {
  configureList,
  configureSave,
  configureDetele,
} from "@/api/threeSolid/dataQueryApi.js";
import { getDict, queryDictList } from "@/api/constant";
export default defineComponent({
  name: "",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    lableData: {
      type: Object,
      default: () => ({}),
    },
    tableInfo: {
      type: String,
      default: "",
    },
  },
  emits: [],
  setup(props, context) {
    const ruleFormRef = ref(null);
    const tableRef = ref(null);
    const state = reactive({
      formVisible: false,
      addVisible: false,
      defaultConfigurationList: {
        dict: [
          { value: "文本框", code: "1" },
          { value: "时间框", code: "2" },
          { value: "下拉框", code: "3" },
        ],
      },
      tableParams: {
        tableInfo: props.tableInfo,
      },
      ruleForm: {
        type: "",
      },
      columns: [
        { label: "字段名", prop: "name" },
        { label: "字段值", prop: "fields" },
        { label: "是否展示", slot: "display" },
        {
          slot: "default",
          label: "操作",
          width: "180px",
        },
      ],
      addParams: {
        tableInfo: "",
        name: "",
        dictConversion: "",
        defaultConfiguration: "1", //1文本、 2 时间、 3 下拉
        seq: "1",
        display: "1",
        fields: "",
        operators: [],
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入字段值",
            trigger: "blur",
          },
        ],
        operators: [
          {
            required: true,
            message: "请选择字段类型",
            trigger: "blur",
          },
        ],
        defaultConfiguration: [
          {
            required: true,
            message: "请选择字段类型",
            trigger: "blur",
          },
        ],
      },
      labelList: "",
      lableDataDict: null,
      dictList: [],
      operatorsList: null,
      operatorsAllList: null,
      tableData: [],
      editorText: "", //编辑时暂存的字段名
    });
    const refData = toRefs(state);
    // 监听弹框显示因此
    watchEffect(() => {
      state.formVisible = props.visible;
      state.lableDataDict = props.lableData;
      if (props.tableInfo) {
        nextTick(() => {
          state.addParams.tableInfo = props.tableInfo;
          refresh();
        });
      }
    });
    const initFrom = (row) => {
      state.addParams = _.cloneDeep(row);
      state.addParams.operators = state.addParams.operators.split(",");
      state.labelList = state.addParams.fields;
      changeDefaultConfiguration(state.addParams.defaultConfiguration);
    };

    // 保存表单数据
    const submit = (formEl) => {
      if (!formEl) return;
      formEl.validate(async (valid) => {
        if (valid) {
          const form = _.cloneDeep(state.addParams);
          form.operators = form.operators.toString();
          const res = await configureSave(form);
          if (res.code === 0) {
            state.addVisible = false;
            ElMessage.success("添加成功");
            refresh();
          }
        } else {
          console.log("error submit!");
          return false;
        }
      });
    };
    // 添加
    const addForm = () => {
      state.addVisible = true;
    };
    const close = () => {
      context.emit("update:visible", false);
      context.emit("refreshDict");
    };
    const lableDataClick = (item) => {
      state.addParams.name = item.label;
      state.addParams.fields = item.prop;
    };
    const changeDefaultConfiguration = (value) => {
      const type = value === "1" ? "text" : value === "2" ? "date" : "dropdown";
      const dateArr = ["date", "datetime", "time", "timestamp"];
      state.operatorsList.dict = [];
      state.operatorsAllList.dict.forEach((element) => {
        const remark = element.remark.split(",");
        if (remark.includes(type)) {
          state.operatorsList.dict.push(element);
        }
      });
    };
    const getDictAxios = async () => {
      const resList = await queryDictList();
      const res = await getDict("operator_fileld");
      state.operatorsList = res;
      state.dictList = resList.dictList;
      state.operatorsAllList = _.cloneDeep(res);
    };
    getDictAxios();
    const editorClick = (row) => {
      state.addVisible = true;
      setTimeout(() => {
        if (row) initFrom(row);
      }, 500);
    };
    const cancelClick = (row) => {
      row.name = state.editorText;
      row.editor = false;
    };
    // 刷新
    const refresh = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 修改字段状态
    const changeStatus = (row) => {
      ElMessageBox({
        title: "修改字段状态",
        message: `您确认要${row.display == "0" ? "显示" : "隐藏"}该字段吗？`,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        type: "warning",
      }).then(
        async () => {
          let param = {
            id: row.id,
            display: row.display == "1" ? "0" : "1",
          };
          changeConfigureSave(param);
        },
        () => {}
      );
    };
    // 删除字段
    const delClick = (row) => {
      ElMessageBox({
        title: "删除",
        message: `您确认要删除该字段吗？`,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        showCancelButton: true,
        type: "warning",
      }).then(
        async () => {
          let param = {
            ids: [row.id],
          };
          const res = await configureDetele(param);
          if (res.code === 0) {
            ElMessage.success("修改成功");
            refresh();
          }
        },
        () => {}
      );
    };
    const changeConfigureSave = async (param) => {
      const res = await configureSave(param);
      if (res.code === 0) {
        ElMessage.success("修改成功");
        refresh();
      }
    };
    const addClose = async () => {
      state.addVisible = false;
      resetForm(ruleFormRef.value);
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
      state.labelList = "";
    };
    return {
      ...refData,
      ruleFormRef,
      tableRef,
      configureList,
      changeStatus,
      addForm,
      submit,
      close,
      lableDataClick,
      changeDefaultConfiguration,
      cancelClick,
      delClick,
      editorClick,
      addClose,
    };
  },
});
</script>
<style lang="scss" scoped>
.HTable {
  height: 40vh;
}
.addForm {
  padding-right: 40px;
}
</style>
